import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { requestAlbumUpdate,getAlbumInArrayById } from '../../actions/album-actions';

import Button  from '../../../common/components/button';
import '../../style/album-dialog.scss';
import { StarRating } from '../star-rating';

class AlbumEditContent extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			album: {
				id: -1,
				title: '',
				description: '',
				favoriteYn: 'N',
				rating: 0
			}
		};

		this.favoriteChanged = this.favoriteChanged.bind(this);
		this.ratingChanged = this.ratingChanged.bind(this);
		this.updateAlbum = this.updateAlbum.bind(this);
		this.updateTitle = this.updateTitle.bind(this);
		this.updateDescription = this.updateDescription.bind(this);
	}

	//TODO: Come back to this.
	componentWillUpdate() {
		if (this.state.album && this.state.album.id === -1) {
			if (this.props.album) {
				this.setState({ album: this.props.album });
			}
		}
	}

	updateTitle(evt) {
		this.setState({album:{title: evt.target.value}});
	}

	updateDescription(evt) {
		this.setState({album:{description: evt.target.value}});
	}

	favoriteChanged(evt) {
		let newState = { album: { ...this.state.album } };
		newState.album.favoriteYn = evt.target.checked ? 'Y' : 'N';
		this.setState(newState);
	}

	ratingChanged(ratingValue) {
		let newState = { album: { ...this.state.album } };
		newState.album.rating = ratingValue;
		this.setState(newState);
	}

	updateAlbum() {
		const { saveChanges, closeDialog } = this.props;
		const updateObject = {
			id: this.state.album.id,
			title: this.state.album.title,
			description: this.state.album.description,
			favoriteYn: this.state.album.favoriteYn,
			rating: this.state.album.rating
		};
		saveChanges(updateObject);
		closeDialog();
	}

	render() {
		return (
			<div>
				<div className="album-edit-container">
					<div className="album-edit-content-container">
						<div className="album-edit-label">Album Name</div>
						<div className="album-edit-control">
							<input
								type="text"
								data-property-name="title"
								value={this.state.album.title}
								onChange={this.updateTitle}
							/>
						</div>
					</div>
					<div className="album-edit-content-container">
						<div className="album-edit-label">Album Description</div>
						<div className="album-edit-control">
							<textarea rows="3" data-property-name="description" onChange={this.updateDescription} value={this.state.album.description ? this.state.album.description : ''}>

							</textarea>
						</div>
					</div>
					<div className="album-edit-content-container">
						<div className="album-edit-label">Date Captured</div>
						<div className="album-edit-control">
							<input type="text" />
						</div>
					</div>
					<div className="album-edit-content-container">
						<div className="album-edit-label">Rating</div>
						<div className="album-edit-control">
							<StarRating rating={this.state.album.rating} starClicked={this.ratingChanged} />
						</div>
					</div>
					<div className="album-edit-content-container">
						<div className="album-edit-label">Favorite</div>
						<div className="album-edit-control">
							<input type="checkbox" checked={this.state.album.favoriteYn === 'Y'} onChange={this.favoriteChanged} />
						</div>
					</div>
				</div>
				<div className="btn-dialog-container">
                    <Button buttonStyle="primary" className="btn-dialog" buttonLabel="Save" onClick={this.updateAlbum} />
					<Button buttonStyle="secondary" className="btn-dialog" buttonLabel="Cancel" onClick={this.props.closeDialog} />
				</div>
			</div>
		);
	}
}

AlbumEditContent.propTypes = {
	album: PropTypes.shape({
		id: PropTypes.number,
		title: PropTypes.string,
		favoriteYn: PropTypes.string
	}),
	closeDialog: PropTypes.func,
	saveChanges: PropTypes.func,
	visible: PropTypes.bool
};

const mapStateToProps = state => {
	return {
		album: getAlbumInArrayById(state.albumList.albums,state.albumItems.collectionId)
	};
};

const mapDispatchToProps = dispatch => {
	return {
		saveChanges: album => {
			dispatch(requestAlbumUpdate(dispatch, album.id, album));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AlbumEditContent);



// WEBPACK FOOTER //
// ./src/album-view/components/dialog/album-edit-content.jsx